module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "width": "20",
      "height": "20"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(7.5 1.25)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M457.486,62.623a1.989,1.989,0,1,1-1.988-1.989,1.988,1.988,0,0,1,1.988,1.989",
      "transform": "translate(-453.105 -60.634)",
      "fill": _vm.color
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M455.1,76.877h0a2.391,2.391,0,0,1-2.392-2.391V70.629a2.392,2.392,0,0,1,4.783,0v3.856a2.391,2.391,0,0,1-2.391,2.391",
      "transform": "translate(-452.71 -64.402)",
      "fill": _vm.color
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M455.008,89.08h0a.679.679,0,0,1-.679-.679V82.439h1.358V88.4a.679.679,0,0,1-.679.679",
      "transform": "translate(-453.512 -71.438)",
      "fill": _vm.color
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M458.56,89.08h0a.679.679,0,0,1-.679-.679V82.439h1.358V88.4a.679.679,0,0,1-.679.679",
      "transform": "translate(-455.272 -71.438)",
      "fill": _vm.color
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78a065e0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/controller/icons/person.vue
// module id = 802
// module chunks = 0